// Reserve labels in priority order after projecting the graph into screen space.
export function layoutNetworkLabels(nodes, positions, hoveredIndex = null) {
  const labels = new Map();
  const occupied = [{ left: 320, right: 480, top: 320, bottom: 490 }];
  const profiles = nodes.map((node, index) => ({ node, index }))
    .filter(({ node }) => node.kind === "profile")
    .sort((a, b) => Number(b.index === hoveredIndex) - Number(a.index === hoveredIndex)
      || Number(Boolean(b.node.ringColor)) - Number(Boolean(a.node.ringColor)) || a.index - b.index);
  for (const { node, index } of profiles) {
    const position = positions[index];
    const scale = position.scale || 1;
    const width = node.name.length * (node.ringColor || index === hoveredIndex ? 6.5 : 5.4) * scale;
    const preferred = node.ringColor ? (position.y > 624 ? -30 : 30) : -13;
    for (const y of [preferred, -preferred]) {
      const x = Math.max(16 + width / 2, Math.min(784 - width / 2, position.x));
      const box = { left: x - width / 2 - 5, right: x + width / 2 + 5,
        top: position.y + y * scale - 10, bottom: position.y + y * scale + 10 };
      if (box.top < 16 || box.bottom > 784 || occupied.some(other =>
        box.left < other.right && box.right > other.left && box.top < other.bottom && box.bottom > other.top)) continue;
      labels.set(index, { x: (x - position.x) / scale, y });
      occupied.push(box);
      break;
    }
  }
  return labels;
}
